import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import React, { useState, useContext, useEffect, useRef, useCallback, useMemo } from "react";
import { useDebouncedSentenceRefresh } from "../../hooks/useDebouncedSentenceRefresh";
import CustModal from "../../../HOC/CustModal";
import Pare from "../../../HOC/ProgressNote/Pare";
import { postRequest, Url } from "../CustomHttp";
import { getSession } from "../Session";
import { userData } from "./ViewDetail";
import Loader from "react-loader-spinner";
import moment from "moment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";
import newJosnData from "./newData.json";
import replaceWords1 from "./replaceWords1.json";
import replaceWords2 from "./replaceWords2.json";
import {
  progressAssessment,
  recomendation,
} from "./AdditionalJson/ProgressAssessment";
import $ from "jquery";
import {
  isCustomPracticeAccount,
  CUSTOM_PRACTICE_META_DEFAULTS,
  applyCustomPracticeFieldChange,
  resolveSessionDurationForPreview,
  resolveCustomPracticeDisplaySessionMinutes,
  getCustomPracticeMetaFromClient,
  mergeProgressNoteSessionMetaFromDoc,
  mergeLiveCustomPracticeSessionMeta,
  buildCustomPracticeSentenceRequestPayload,
  normalizeCustomPracticeFrontJson,
  buildObjectivesChildrenFromNotes,
  scheduleFrontJsonCheckboxRestore,
  resolveSessionDurationMinutes,
  CUSTOM_PRACTICE_CLIENT_NOTE_SECTION,
  buildDocumentSavePayload,
  resolveDocumentSignatures,
  buildSignatureParagraphHtml,
  formatSignatureLine,
  resolveSignOffButtonState,
  isDocumentContentEditable,
  isClinicianFinalSignOnly,
  getSignOffButtonLabel,
  getSignOffConfirmPrompt,
  normalizeDocumentSignStatus,
  resolveDocumentSignStatusesFromApi,
  isDocumentViewOnlyInEditor,
  resolveDocumentEditorAccess,
  buildStoreClientDocumentViewEditFlag,
  stripEmbeddedSignaturesFromHtml,
  resolveDocumentCreatedBy,
} from "../../utils/customPractice";
import CustomPracticeHeaderFields, {
  CustomPracticeSessionDuration,
} from "../../components/customPractice/CustomPracticeHeaderFields";
import "../../components/customPractice/CustomPracticeHeaderFields.css";

function buildCustomPracticeSections(notesArr = []) {
  const objectivesChildren = buildObjectivesChildrenFromNotes(notesArr);

  let sections = [...newJosnData];
  if (objectivesChildren.length > 0) {
    sections.unshift({
      name: "Objectives",
      key: "objectives",
      child: objectivesChildren,
    });
  }

  const interventionsIdx = sections.findIndex((s) => s.key === "interventions");
  if (interventionsIdx !== -1) {
    sections = [
      ...sections.slice(0, interventionsIdx + 1),
      CUSTOM_PRACTICE_CLIENT_NOTE_SECTION,
      ...sections.slice(interventionsIdx + 1),
    ];
  } else {
    sections.push(CUSTOM_PRACTICE_CLIENT_NOTE_SECTION);
  }

  return sections;
}

function getInitialProgressNoteJson() {
  if (isCustomPracticeAccount()) {
    return buildCustomPracticeSections([]);
  }
  return newJosnData;
}

export default function ProgressNote(props) {
  let checkSigned = 0;
  let supervisorSigned = 0;
  let showSigned = 0;

  const { userInfo, changePage, editId } = useContext(userData);
  const isCustomPractice = isCustomPracticeAccount();
  const [ProgressNoteJson, setProgressNoteJson] = useState(getInitialProgressNoteJson);
  const [customPracticeMeta, setCustomPracticeMeta] = useState({
    ...CUSTOM_PRACTICE_META_DEFAULTS,
  });
  const customPracticeMetaRef = useRef(customPracticeMeta);
  customPracticeMetaRef.current = customPracticeMeta;
  const [Statement, setStatement] = useState("");
  const [defaultStatement, setDefaultStatement] = useState("");
  const [Durations, setDurations] = useState("");
  const [statusCollapse, setStatusCollapse] = useState(null);
  const [DateOfServices, setDateOfServices] = useState("");
  const [viewEdit, setViewEdit] = useState({
    confirmChange: false,
    wordsReplaced: false,
    diagnosis: userInfo.client_diagnosis ?? [],
    changeId: false,
    showModal: false,
    client_document_id: 0,
    confirmSave: false,
    editData: false,
    viewStatement: false,
    editBy: "",
    editTime: "",
    signed_at: "",
    signed: 1,
    supervisorSigned: 1,
    is_updated: 0,
    created_by: 0,
    supervisor_signed_by: 0,
    supervisor_signature: "",
    supervisor_signed_at: "",
    status_updated_by_role: "",
    viewStatement:""
  });
  const [Data, setData] = useState("");
  const [SignOff, setSignOff] = useState({
    signOff: false,
    signOffConfirm: false,
    signed: 1,
    supervisor_signed: 1,
  });
  const [commonData, setCommonData] = useState({
    date_of_service: new Date(),
    showError: false,
    count: 0,
    replicateNoteData: [],
    sessionDurationCheck: isCustomPractice ? "0" : "60",
    ...(isCustomPractice ? { sessionDuration: "0" } : {}),
  });
  const [selectedSearchIndex, setSelectedSeachIndex] = useState(0);
  const [totalSearch, setTotalSearch] = useState(0);
  const URL = "/sentence-builder";
  const [payloadData, setPayloadData] = useState();
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const [editDataofServies, setEditDateofServies] = useState("");

  const [selectAllData, setSelectAllData] = useState({})

  const [sentenceLoader, setSentenceLoader] = useState(false)
  const [checkboxLoader, setCheckboxLoader] = useState(false)
  const [loading, setLoading] = useState(false)
  const [documentMetaLoaded, setDocumentMetaLoaded] = useState(!(editId > 0))
  const handleChildToParent = (date) => {
    setEditDateofServies(date);
    // console.log(
    //   "edit date of cervice ---------------->",
    //   date,
    //   editDataofServies
    // );
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };
  const onSelectedSearchIndex = (flag) => {
    var documentContent = $("#progressNote");
    if (documentContent.length >= 0) {
      var myVar = $(".searchingTextBG");
      setTotalSearch(myVar.length);
      if (myVar.length > 0) {
        // setStatusCollapse(!statusCollapse)
        $(".collapse").addClass("show");
      }
      // console.log("myVar[selectedSearchIndex]",myVar[selectedSearchIndex]);
      $(".selectedSearchIndex").removeClass("selectedSearchIndex");
      let indexFlag = 0;
      // console.log(flag);
      if (flag == "up") {
        if (selectedSearchIndex == 0) {
          setSelectedSeachIndex(myVar.length - 1);
          indexFlag = myVar.length - 1;
        } else {
          setSelectedSeachIndex(selectedSearchIndex - 1);
          indexFlag = selectedSearchIndex - 1;
        }
      } else {
        if (selectedSearchIndex == myVar.length - 1) {
          setSelectedSeachIndex(0);
          indexFlag = 0;
        } else {
          setSelectedSeachIndex(selectedSearchIndex + 1);
          indexFlag = selectedSearchIndex + 1;
        }
      }

      $(myVar[indexFlag]).addClass("selectedSearchIndex");
      myVar[indexFlag].scrollIntoView({ block: "center" });
      // setSelectedSeachIndex(indexFlag)

      // console.log("selectedSearchIndex", selectedSearchIndex, indexFlag);
    }
  };

  function keepSentenceBetweenSpecificWords(sentence, startWord, endWord) {
    // Find the index of the start word
    const startIndex = sentence.indexOf(startWord);
    if (startIndex === -1) {
        // return "Start word not found in the sentence.";
    }

    // Find the index of the end word
    const endIndex = sentence.indexOf(endWord);
    if (endIndex === -1) {
        // return "End word not found in the sentence.";
    }

    // Extract the sentence between the start and end words
    const beforeSentence = sentence.substring(0, startIndex).trim();
    let betweenSentence;
    if(endIndex === -1) {
      betweenSentence = sentence.substring(startIndex + startWord.length).trim();
    } else {
      betweenSentence = sentence.substring(startIndex + startWord.length, endIndex).trim();
    }
    const afterSentence = sentence.substring(endIndex + endWord.length).trim();
    // const betweenSentence = sentence.substring(startIndex + startWord.length, middleIndex).trim();

    return {
      beforeSentence: startIndex === -1 ? "" : beforeSentence,
      betweenSentence: startIndex === -1 ? "" : betweenSentence,
      afterSentence: endIndex === -1 ? "" : afterSentence
  };
}

  function replaceWords(sentence, replacements) {
    // Split the sentence into words
    // const words = sentence.split(/\s+/);
  
    // Iterate through each word
    // const replacedSentence = words.map(word => {
      // Check if the word exists in the replacements object
    //   if (replacements.hasOwnProperty(word)) {
    //     // If it does, replace it with the corresponding value
    //     return replacements[word];
    //   } else {
    //     // If not, keep the original word
    //     return word;
    //   }
    // });
    // const sa = sentence
    const newSs = keepSentenceBetweenSpecificWords(sentence, "MSE", "Goal 1:")
    let newSentence = newSs.betweenSentence === "" ? sentence : newSs.betweenSentence;
    // console.log("newSentence",newSentence)
    for (const [word, replacement] of Object.entries(replacements)) {
      // const regex = new RegExp('\\b' + word + '\\b', 'gi');
      // sentence = sentence.replace(regex, replacement);
      newSentence = newSentence.replace(word, replacement);
    }
    // return sentence;
  
    setStatement(newSs.betweenSentence === "" ? newSentence :(newSs.beforeSentence+ " MSE " +newSentence+ (newSs.afterSentence !== "" ? "Goal 1:" : "")+ newSs.afterSentence))
    setViewEdit(prev => {
      return {
        ...prev,
        wordsReplaced:true,
      }
    })
    // console.log("replaceWords called")
    // Join the words back into a sentence
    // return replacedSentence.join(' ');
  }
  

  const onChangeHandler = (e) => {
    // console.log("call");
    // if (!e.target.value) {
    //   // $(".collapse").removeClass("show");
    //   $(".collapsible").removeClass("show");
    //   // setStatusCollapse(!statusCollapse)
    // }
    if (e.target.value == "" || !e.target.value) {
      setSearchLoader(true)
    setTimeout(() => {
      setSearchLoader(false)
    }, 2000);
    setStatusCollapse(false)
    setTimeout(() => {
      setStatusCollapse(null)
    }, 2000);
      // console.log("e.target.value", typeof e.target.value);
      setSelectedSeachIndex(0);
      setTotalSearch(0);
      // $(".collapse").removeClass("show");
      $(".collapsible").removeClass("show");
      const parentCollapse = $('.parentCollapsibleCheckbox input')
      for(let i = 0; i < parentCollapse.length; i++){
        if($(`#${parentCollapse[i].id}`).is(':checked')){
          const name = $(`#${parentCollapse[i].id}`).attr('id')
          $(`#${name}Collapse`).addClass("show")
        }
      }
      let value = e.target.value;
      // console.log(value);
      var documentContent = $("#progressNote");
      // setStatusCollapse(!statusCollapse)
      var myVar = $(".searchingTextBG");
      //Remove class
      for (let l = 0; l < myVar.length; l++) {
        const element = myVar[l];
        let findElement = $(element)[0];
        let s = findElement.innerHTML.replaceAll(
          /<span class="searchingTextBG">/gi,
          ""
        );
        s.replaceAll(/<\/span>/gi, "");
        // findElement.innerHTML = s;
      }
      let pattern = new RegExp("(" + value + ")(?![^<>]*>)", "ig");
      for (let index = 0; index < $(".collapsible").length; index++) {
        const element = $(".collapsible")[index];
        for (let k = 0; k < $("label", element).length; k++) {
          const Parentelement = $("label", element)[k];
          const elementText = $(Parentelement).text();
          $(Parentelement).html(
            elementText.replaceAll(pattern, function (str) {
              return str;
            })
          );
        }
      }
    } else {
      let value = e.target.value;
      // console.log(value);
      var documentContent = $("#progressNote");
      // setStatusCollapse(!statusCollapse)
      var myVar = $(".searchingTextBG");
      if (value != "") {
        $(".collapse").addClass("show");
      }
      //Remove class
      for (let l = 0; l < myVar.length; l++) {
        const element = myVar[l];
        let findElement = $(element)[0];
        let s = findElement.innerHTML.replaceAll(
          /<span class="searchingTextBG">/gi,
          ""
        );
        s.replaceAll(/<\/span>/gi, "");
        findElement.innerHTML = s;
      }
      let pattern = new RegExp("(" + value + ")(?![^<>]*>)", "ig");
      for (let index = 0; index < $(".collapsible").length; index++) {
        const element = $(".collapsible")[index];
        for (let k = 0; k < $("label", element).length; k++) {
          const Parentelement = $("label", element)[k];
          const elementText = $(Parentelement).text();
          $(Parentelement).html(
            elementText.replaceAll(pattern, function (str) {
              return "<span class='searchingTextBG'>" + str + "</span>";
            })
          );
        }
      }
    }
    // // filter in Card
    // if (documentContent.length > 0) {
    //     const tempInnerHtml = document.getElementsByClassName("fs-6 text-dark form-label mb-0")
    //     var str1 = documentContent[0].children[0].innerHTML
    //     str1 = str1.replaceAll(/<span class="searchingTextBG">/gi, "")
    //     str1 = str1.replaceAll(/<\/span>/gi, "")
    //     var reg = new RegExp(value, 'gi');
    //     var foundIndex = str1.match(reg);
    //     if (foundIndex) {
    //         let pattern = new RegExp("(" + value + ")(?![^<>]*>)", "ig")
    //         // var query = new RegExp("("+searchTxtBox.val()+")", "im");
    //         documentContent[0].children[0].innerHTML = str1.replaceAll(pattern, function (str) { return "<span class='searchingTextBG'>" + str + "</span>" });
    //     } else {
    //         documentContent[0].children[0].innerHTML = str1
    //     }
    // }
    if (e.target.value != "") {
      onSelectedSearchIndex("down");
    }
  };
  const onOptimisedHandleChange = debounce(onChangeHandler, 350);
  const searchRef = useRef(null)
  const [searchLoader, setSearchLoader] = useState(false)

  const syncSessionDurationMinutes = (totalMinutes) => {
    const minutes = isCustomPractice
      ? resolveSessionDurationMinutes(totalMinutes, true)
      : totalMinutes;
    if (minutes !== "" && minutes !== null && minutes !== undefined) {
      setCommonData((prev) => ({
        ...prev,
        sessionDuration: String(minutes),
        sessionDurationCheck: String(minutes),
      }));
    }
  };

  const applyCustomPracticeFromDoc = (doc) => {
    if (!doc) {
      return;
    }
    const meta = mergeProgressNoteSessionMetaFromDoc(doc, userInfo);
    setCustomPracticeMeta(meta);
    syncSessionDurationMinutes(
      resolveCustomPracticeDisplaySessionMinutes(meta, doc.session_duration)
    );
  };

  const headerPreviewEpochRef = useRef(0);
  const accordionPreviewEpochRef = useRef(0);
  const skipMetaRefreshOnLoadRef = useRef(editId > 0);

  const refreshStatementWithCustomMeta = useCallback(
    async (meta) => {
      if (!isCustomPractice || viewEdit.client_document_id === 0) {
        return;
      }
      const session = getSession("userData") || {};
      if (
        !isDocumentContentEditable(
          viewEdit.signed,
          viewEdit.supervisorSigned,
          userInfo.user_role_slug,
          session.id,
          userInfo.creator_id
        )
      ) {
        return;
      }
      const requestId = ++headerPreviewEpochRef.current;
      const sessionDuration = resolveCustomPracticeDisplaySessionMinutes(
        meta,
        commonData.sessionDuration
      );
      try {
        const postdata = await postRequest(
          URL,
          buildCustomPracticeSentenceRequestPayload({
            payloadData,
            userInfo,
            viewEdit,
            commonData,
            customPracticeMeta: meta,
            metaOverride: meta,
            sessionDuration,
          }),
          true
        );
        if (requestId !== headerPreviewEpochRef.current) {
          return;
        }
        if (postdata?.paragraph) {
          setStatement(postdata.paragraph);
        }
      } catch {
        // ignore preview refresh failures
      }
    },
    [
      isCustomPractice,
      payloadData,
      viewEdit,
      userInfo,
      commonData,
      URL,
      customPracticeMeta,
    ]
  );

  const scheduleMetaRefresh = useDebouncedSentenceRefresh(
    refreshStatementWithCustomMeta,
    [URL, viewEdit.client_document_id]
  );

  useEffect(() => {
    if (!isCustomPractice || !viewEdit.client_document_id) {
      return;
    }
    if (skipMetaRefreshOnLoadRef.current) {
      skipMetaRefreshOnLoadRef.current = false;
      return;
    }
    scheduleMetaRefresh(customPracticeMeta);
  }, [viewEdit.client_document_id, isCustomPractice]);

  useEffect(() => {
    if (!isCustomPractice || !userInfo?.id) {
      return;
    }
    setCustomPracticeMeta((prev) => ({
      ...getCustomPracticeMetaFromClient(userInfo),
      ...prev,
      ref_id: prev.ref_id || userInfo.ref_id || "",
      ins_id: prev.ins_id || userInfo.ins_id || "",
    }));
  }, [isCustomPractice, userInfo?.id, userInfo?.ref_id, userInfo?.ins_id]);

  const onCustomPracticeFieldChange = (field) => (e) => {
    const value = e.target.value;
    let nextMeta;
    let computedMinutes;
    setCustomPracticeMeta((prev) => {
      const result = applyCustomPracticeFieldChange(prev, field, value);
      nextMeta = result.next;
      computedMinutes = result.computed;
      return nextMeta;
    });
    if (computedMinutes != null && computedMinutes !== undefined) {
      syncSessionDurationMinutes(computedMinutes);
      setCommonData((prev) => ({
        ...prev,
        sessionDuration: String(computedMinutes),
        sessionDurationCheck: String(computedMinutes),
      }));
      if (viewEdit.client_document_id !== 0) {
        postRequest(
          '/update-session-duration',
          {
            sessionDuration: computedMinutes,
            client_document_id: viewEdit.client_document_id,
          },
          true
        );
      }
    } else if (
      nextMeta &&
      (!nextMeta.start_time?.trim() || !nextMeta.end_time?.trim())
    ) {
      syncSessionDurationMinutes(0);
      setCommonData((prev) => ({
        ...prev,
        sessionDuration: '0',
        sessionDurationCheck: '0',
      }));
      if (viewEdit.client_document_id !== 0) {
        postRequest(
          '/update-session-duration',
          {
            sessionDuration: 0,
            client_document_id: viewEdit.client_document_id,
          },
          true
        );
      }
    }
    if (nextMeta) {
      customPracticeMetaRef.current = nextMeta;
      setPayloadData((prev) => ({
        ...(prev && typeof prev === "object" ? prev : {}),
        ...nextMeta,
      }));
      const commitOnlyField = field === "ref_id" || field === "ins_id";
      const runImmediately =
        field === "place_of_service" ||
        field === "method_of_contact" ||
        field === "start_time" ||
        field === "end_time";
      if (commitOnlyField) {
        return;
      }
      accordionPreviewEpochRef.current += 1;
      if (runImmediately) {
        refreshStatementWithCustomMeta(nextMeta);
      } else {
        scheduleMetaRefresh(nextMeta);
      }
    }
  };

  const onCustomPracticeFieldCommit = () => {
    const meta = customPracticeMetaRef.current;
    if (meta && typeof meta === 'object') {
      accordionPreviewEpochRef.current += 1;
      refreshStatementWithCustomMeta(meta);
    }
  };

  const clearSearch = () => {
    setSearchLoader(true)
    setTimeout(() => {
      setSearchLoader(false)
    }, 2000);
    setStatusCollapse(false)
    setTimeout(() => {
      setStatusCollapse(null)
    }, 2000);
    const searchValue = searchRef.current.value;
    searchRef.current.value = '';
      setSelectedSeachIndex(0);
      setTotalSearch(0);
      var documentContent = $("#progressNote");
      var myVar = $(".searchingTextBG");
      //Remove class
      for (let l = 0; l < myVar.length; l++) {
        const element = myVar[l];
        let findElement = $(element)[0];
        let s = findElement.innerHTML.replaceAll(
          /<span class="searchingTextBG">/gi,
          ""
        );
        s.replaceAll(/<\/span>/gi, "");
        // findElement.innerHTML = s;
      }
      let pattern = new RegExp("(" + searchValue + ")(?![^<>]*>)", "ig");
      for (let index = 0; index < $(".collapsible").length; index++) {
        const element = $(".collapsible")[index];
        for (let k = 0; k < $("label", element).length; k++) {
          const Parentelement = $("label", element)[k];
          const elementText = $(Parentelement).text();
          $(Parentelement).html(
            elementText.replaceAll(pattern, function (str) {
              return str;
            })
          );
        }
      }
      $(".collapsible").removeClass("show");
      const parentCollapse = $('.parentCollapsibleCheckbox input')
      for(let i = 0; i < parentCollapse.length; i++){
        if($(`#${parentCollapse[i].id}`).is(':checked')){
          const name = $(`#${parentCollapse[i].id}`).attr('id')
          $(`#${name}Collapse`).addClass("show")
        }
      }
  } 
  

  const handleFrontJsonPersisted = useCallback((frontJson, documentId) => {
    const session = getSession("userData") || {};
    const mergedFrontJson = isCustomPractice
      ? mergeLiveCustomPracticeSessionMeta(
          frontJson,
          customPracticeMetaRef.current
        )
      : frontJson;
    setViewEdit((prev) => ({
      ...prev,
      client_document_id: documentId || prev.client_document_id,
      created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
    }));
    setSelectAllData(mergedFrontJson);
    setPayloadData((prev) => ({
      ...(prev && typeof prev === "object" ? prev : {}),
      ...mergedFrontJson,
      client_document_id: documentId || prev?.client_document_id,
    }));
  }, [isCustomPractice]);

  const handleFormSelectionChange = useCallback((selection) => {
    const mergedSelection = isCustomPractice
      ? mergeLiveCustomPracticeSessionMeta(
          selection,
          customPracticeMetaRef.current
        )
      : selection;
    setPayloadData((prev) => ({
      ...(prev && typeof prev === "object" ? prev : {}),
      ...mergedSelection,
    }));
  }, [isCustomPractice]);

  const saveStatement = async () => {
    const session = getSession("userData") || {};
    if (
      isDocumentViewOnlyInEditor({
        editId,
        documentMetaLoaded,
        signed: viewEdit.signed,
        supervisorSigned: viewEdit.supervisorSigned,
        userRoleSlug: userInfo.user_role_slug,
        userId: session.id,
        clientCreatorId: userInfo.creator_id,
      })
    ) {
      return;
    }
    const viewEditFlag = buildStoreClientDocumentViewEditFlag(viewEdit.confirmChange);
    const savePayload = buildDocumentSavePayload({
      payloadData,
      editData: viewEdit.editData,
      extras: {
        client_document_id: viewEdit.client_document_id,
        view_edit_flag: viewEditFlag,
        sessionDuration: resolveCustomPracticeDisplaySessionMinutes(
          customPracticeMeta,
          commonData.sessionDuration
        ),
        ...(isCustomPractice ? customPracticeMeta : {}),
      },
    });
    const postData = await postRequest(
      "/store-client-document",
      {
        Statement,
        data: savePayload,
        document_type: "progress_note",
        client_id: userInfo.id,
        client_document_id: viewEdit.client_document_id,
      },
      true
    );
    if (postData) {
      const frontJson = normalizeCustomPracticeFrontJson(savePayload);
      setViewEdit((prev) => ({
        ...prev,
        client_document_id: postData.client_document_id,
        confirmSave: true,
        confirmChange: prev.confirmChange || Boolean(viewEditFlag),
        editData: frontJson,
        created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
      }));
      setSelectAllData(frontJson);
    }
  };

  const signOffFun = async () => {
    const postData = await postRequest(
      "/client-document-update-status",
      {
        client_document_id: viewEdit.client_document_id,
        document_type: "progress_note",
        client_id: userInfo.id,
        signed: SignOff.signed,
        supervisor_signed: SignOff.supervisor_signed,
      },
      true
    );
    if (postData) {
      changePage({ id: 6 });
    }
  };

  const setEditableCheckBox = async () => {
    const postData = await postRequest(
      "/client-document-info",
      { client_document_id: editId },
      true
    );
    if (!isMountedRef.current) {
      return;
    }
    // console.log("/client-document-info", postData);
    if (postData?.status && postData?.data) {
      const { signed, supervisorSigned } = resolveDocumentSignStatusesFromApi(
        postData.data
      );
      const hasFrontJson =
        postData.data.front_json != null &&
        postData.data.front_json !== '' &&
        postData.data.front_json !== 'null';

      if (hasFrontJson) {
        const frontJson = normalizeCustomPracticeFrontJson(
          JSON.parse(postData.data.front_json)
        );
        scheduleFrontJsonCheckboxRestore(frontJson);
        applyCustomPracticeFromDoc(postData.data);
        setStatement(postData.data.paragraph);
        setSelectAllData(frontJson);
        setPayloadData(frontJson);
        const resolvedMinutes = isCustomPractice
          ? resolveSessionDurationMinutes(postData.data.session_duration, true)
          : postData.data.session_duration;
        setCommonData((prev) => ({
          ...prev,
          date_of_service: postData.data.date_of_service,
          count: 1,
          ...(resolvedMinutes !== '' && resolvedMinutes != null
            ? {
                sessionDuration: String(resolvedMinutes),
                sessionDurationCheck: String(resolvedMinutes),
              }
            : {}),
        }));
        handleChildToParent(postData.data.date_of_service);
        getDocData(postData.data);
        setViewEdit((prev) => ({
          ...prev,
          confirmChange: postData.data.view_edit_flag ? true : false,
          client_document_id: editId,
          editData: frontJson,
          diagnosis: postData.data.client_document_diagnosis ?? [],
          editBy: postData.data.statusUpdatedUserName,
          editTime: postData.data.statusUpdatedDateTime,
          signed_at: postData.data.signed_at,
          signed,
          supervisorSigned,
          statusSuperVisorSigned: postData.data.statusUpdatedSupervisorUserName,
          signature: postData.data.signature,
          supervisor_signature: postData.data.supervisor_signature,
          supervisor_signed_at: postData.data.supervisor_signed_at,
          status_updated_by_role: postData.data.status_updated_by_role,
          created_by: postData.data.created_by ?? 0,
          supervisor_signed_by: postData.data.supervisor_signed_by ?? 0,
        }));
      } else {
        applyCustomPracticeFromDoc(postData.data);
        if (postData.data.paragraph) {
          setStatement(postData.data.paragraph);
        }
        setViewEdit((prev) => ({
          ...prev,
          client_document_id: editId,
          confirmChange: postData.data.view_edit_flag ? true : false,
          signed,
          supervisorSigned,
          created_by: postData.data.created_by ?? prev.created_by ?? 0,
          diagnosis: postData.data.client_document_diagnosis ?? prev.diagnosis,
          editBy: postData.data.statusUpdatedUserName ?? prev.editBy,
          editTime: postData.data.statusUpdatedDateTime ?? prev.editTime,
        }));
        setCommonData((prev) => ({
          ...prev,
          date_of_service: postData.data.date_of_service ?? prev.date_of_service,
          count: 1,
        }));
      }
    }
    if (isMountedRef.current) {
      setDocumentMetaLoaded(true);
    }
  };

  //call date submit function
  const submitDatefunction = async () => {
    if (commonData.date_of_service === "Invalid date") {
      setCommonData((prev) => ({
        ...prev,
        showError: true,
        isLoading: false,
        count: 22,
      }));
      return;
    }

    setCommonData((prev) => ({ ...prev, showError: false, isLoading: true }));

    const noteData = await postRequest(
      "/latest-notes",
      { client_id: userInfo.id },
      true
    );
    const postData = await postRequest(
      "/set-date-of-service",
      {
        client_document_id: viewEdit.client_document_id,
        date_of_service: commonData.date_of_service,
        client_id: userInfo.id,
        document_type: "progress_note",
      },
      true
    );
    if (postData) {
      setDateOfServices(postData.date_of_service);
      const newDocId = postData.client_document_id;
      const session = getSession("userData") || {};
      setViewEdit((prev) => ({
        ...prev,
        client_document_id: newDocId,
        created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
      }));
      const defaultMinutes = isCustomPractice ? 0 : null;
      setCommonData((prev) => ({
        ...prev,
        date_of_service: postData.date_of_service,
        showError: false,
        isLoading: false,
        count: 1,
        ...(defaultMinutes !== null
          ? {
              sessionDuration: String(defaultMinutes),
              sessionDurationCheck: String(defaultMinutes),
            }
          : {}),
      }));
      if (isCustomPractice && newDocId) {
        await postRequest(
          "/update-session-duration",
          {
            sessionDuration: defaultMinutes,
            client_document_id: newDocId,
          },
          true
        );
      }
      getDocData(postData);
      if (noteData?.status) {
        applyLatestNotesToForm(noteData);
      }
    } else {
      setCommonData((prev) => ({ ...prev, isLoading: false }));
    }
  };

  //changeCommon data
  const changeCommonData = useCallback(() => {
    if (viewEdit.client_document_id === 0) {
      setCommonData((prev) => ({ ...prev, count: 2 }));
    }
  }, [viewEdit.client_document_id]);

  const pareCommonData = useMemo(
    () => ({ commonData, changeCommonData }),
    [commonData, changeCommonData]
  );

  const sessionUser = getSession("userData") || {};
  const signOffState = resolveSignOffButtonState({
    signed: viewEdit.signed,
    supervisorSigned: viewEdit.supervisorSigned,
    userRoleSlug: userInfo.user_role_slug,
    userSupervisorId: userInfo.user_supervisor_id,
    documentCreatedBy: viewEdit.created_by,
    userId: sessionUser.id,
    clientSupervisorId: userInfo.client_supervisor_id,
  });
  checkSigned = signOffState.checkSigned;
  supervisorSigned = signOffState.supervisorSigned;
  showSigned = signOffState.showSigned;
  const {
    contentEditable,
    isViewOnlyDocument,
    showDocumentEditActions,
  } = resolveDocumentEditorAccess({
    editId,
    documentMetaLoaded,
    signed: viewEdit.signed,
    supervisorSigned: viewEdit.supervisorSigned,
    userRoleSlug: userInfo.user_role_slug,
    userId: sessionUser.id,
    clientCreatorId: userInfo.creator_id,
  });
  const clinicianFinalSignOnly = isClinicianFinalSignOnly(
    viewEdit.signed,
    viewEdit.supervisorSigned,
    userInfo.user_role_slug,
    sessionUser.id,
    userInfo.creator_id,
    viewEdit.created_by
  );
  const refreshReplicateList = async () => {
    if (viewEdit.client_document_id === 0) return;
    await getDocData();
  };
  // Replicate-note list only — does not control start/edit button state.
  const getDocData = async (data) => {
    const postData = await postRequest(
      "/get-progressnote-document-data",
      { client_id: userInfo.id },
      true
    );
    // console.log(
    //   "get-progressNote-document-data before",
    //   postData,
    //   commonData,
    //   data
    // );
    if (postData) {
      if (postData.status) {
        const updateData = {};
        if (data) {
          updateData.date_of_service = data.date_of_service;
          const resolvedMinutes = isCustomPractice
            ? resolveSessionDurationMinutes(data.session_duration, true)
            : data.session_duration;
          if (resolvedMinutes !== '' && resolvedMinutes != null) {
            updateData.sessionDuration = String(resolvedMinutes);
          }
        }
        // Do not re-apply session-meta from set-date-of-service response.
        // That payload does not include freshly edited start/end time and can
        // race with the time picker flow, clearing fields on first note start.

        updateData.replicateNoteData = postData.data ?? [];
        updateData.showError = false;

        setCommonData((prev) => ({
          ...prev,
          ...updateData,
          sessionDuration:
            updateData.sessionDuration ?? prev.sessionDuration,
          sessionDurationCheck:
            updateData.sessionDuration ?? prev.sessionDurationCheck,
        }));
      }
    } 
    // console.log("get-progressNote-document-data after", postData, commonData);
  };

  // getFields
  const getFields = async(e) => {
    const getFrontData = commonData.replicateNoteData.find(
      (f) => f.id == e.target.value
    );
    // console.log(getFrontData,'getFrontDatagetFrontData')
    setCommonData({
      ...commonData,
      // date_of_service: getFrontData.date_of_service,
      sessionDuration: getFrontData.session_duration,
      count: 1,
    });
   
      
    if (getFrontData) {
      const sessionMeta = mergeProgressNoteSessionMetaFromDoc(
        getFrontData,
        userInfo
      );
      applyCustomPracticeFromDoc(getFrontData);
      const apiPayload = {
        ...JSON.parse(getFrontData.front_json),
        client_document_id: viewEdit.client_document_id,
        highlightedWordsId: "",
        highlightedWords: "",
        sessionDuration: getFrontData.session_duration,
        ...sessionMeta,
      };
      const postdata = await postRequest(URL, apiPayload, true);
      if (postdata?.paragraph) {
        setStatement(postdata.paragraph);
      } else if (getFrontData.paragraph) {
        setStatement(getFrontData.paragraph);
      }

      const frontJson = normalizeCustomPracticeFrontJson(
        JSON.parse(getFrontData.front_json)
      );
      scheduleFrontJsonCheckboxRestore(frontJson);
      setViewEdit(prev => ({
        ...prev,
        editData: frontJson,
      }));
      setSelectAllData(frontJson);
    }
  };

  const getDateOfService = () => {
    return commonData.date_of_service;
  };
  //download
  const downloadDocument = async () => {
    let signatureText = "<div className='col-xs-12 mt-4'><hr />";

    signatureText += buildSignatureParagraphHtml(resolveDocumentSignatures({
      signed: viewEdit.signed,
      supervisor_signed: viewEdit.supervisorSigned,
      signature: viewEdit.signature,
      supervisor_signature: viewEdit.supervisor_signature,
      signed_at: viewEdit.editTime,
      supervisor_signed_at: viewEdit.supervisor_signed_at,
      status_updated_by_role: viewEdit.status_updated_by_role,
      created_by: viewEdit.created_by,
      supervisor_signed_by: viewEdit.supervisor_signed_by,
    }));
    signatureText += `</div>`;

    const postData = await postRequest(
      "/download-client-document-pdf",
      { 
        client_document_id: viewEdit.client_document_id,
        signature: signatureText
      },
      true
    );
    if (postData) {
      const link = document.createElement("a");
      link.target = "_blank";
      // link.href = Url + postData.split("/html")[1];
      link.href = postData;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  /** Load Objectives checkboxes from latest (signed) treatment plan via /latest-notes */
  const applyLatestNotesToForm = (postData) => {
    if (!postData) {
      return;
    }
      // console.log("Latest notes data ================>>>>>>>>> postData",postData)
      let progressAssessmentJson = {
        name: "Progress",
        key: "parp",
        child: [],
      };
      if (postData.status) {
        // console.log('postData.status',postData.status)
        // console.log('postData.data.notesArr && postData.data.notesArr.length > 0',postData.data.notesArr, postData.data.notesArr.length > 0)
        // console.log(postData.data.notesArr && postData.data.notesArr.length > 0)

        if (postData.data.notesArr && postData.data.notesArr.length > 0) {
          let tmpGoal = [];
          for (let i in postData.data.notesArr) {
            for (let j in postData.data.notesArr[i]) {
              let tmpTag = document.createElement("div");
              tmpTag.innerHTML = postData.data.notesArr[i][j];

              if (j.startsWith("goal_")) {
                tmpGoal.push({
                  name: tmpTag.innerText,
                  key: j,
                  for: "normal",
                  type: "checkbox",
                  child: [progressAssessment],
                });
              }
            }
          }
          progressAssessmentJson.child = tmpGoal;
          if (tmpGoal.length > 0) {
            progressAssessmentJson.child[tmpGoal.length - 1] = {
              ...progressAssessmentJson.child[tmpGoal.length - 1],
              notes: "true",
              notesText: [
                {
                  text: "hello",
                  show_text: false,
                },
              ],
              show_notes: true,
            };
          }
          setViewEdit(prev => {
            return { ...prev, notes_id: postData.data.notes_id }
          });
          // console.log("postData.data.notes_id",postData.data.notes_id)
        }
      }
      progressAssessmentJson.child = progressAssessmentJson.child.reverse();
      progressAssessmentJson.child.push({
        name: "note",
        key: "note",
        for: "inline-notes",
        textArea: true,
        type: "checkbox",
        placeholder: "Add your notes here",
      });

      if (isCustomPractice) {
        const customJson = buildCustomPracticeSections(
          postData.data?.notesArr || []
        );
        customJson.push(progressAssessmentJson);
        customJson.push(recomendation);
        setProgressNoteJson(customJson);
      } else {
        const newJson = [...newJosnData];
        newJson.push(progressAssessmentJson);
        newJson.push(recomendation);
        setProgressNoteJson(newJson);
      }
  };

  const getProgressNote = async () => {
    const postData = await postRequest(
      "/latest-notes",
      { client_id: userInfo.id },
      true
    );
    applyLatestNotesToForm(postData);
  };

  const submitSessionDuration = async (sessionDuration) => {
    if (/^-?\d+$/.test(sessionDuration.target.value)) {
      setDurations(sessionDuration.target.value);
      // console.log("tif", sessionDuration.target.value);
      setCommonData({
        ...commonData,
        sessionDuration: sessionDuration.target.value,
        sessionDurationCheck: sessionDuration.target.value,
      });
      const postData = await postRequest(
        "/update-session-duration",
        {
          sessionDuration: sessionDuration.target.value,
          client_document_id: viewEdit.client_document_id,
        },
        true
      );
      if (postData) {
        // console.log("Submit Session Duration", postData);
      }
    } else {
      // console.log("telse", sessionDuration.target.value);
      setCommonData({ ...commonData, sessionDurationCheck: "" });
      if (sessionDuration.target.value === "") {
        const postData = await postRequest(
          "/update-session-duration",
          {
            sessionDuration: sessionDuration.target.value,
            client_document_id: viewEdit.client_document_id,
          },
          true
        );
        if (postData) {
          // console.log("Submit Session Duration", postData);
        }
      }
    }
    if (sessionDuration?.target?.value && payloadData) {
      payloadData.sessionDuration = sessionDuration.target.value;
      const postdata = await postRequest(URL, payloadData, true);
      if (postdata) {
        setStatement(postdata.paragraph);
        // setDefaultStatement(postdata.paragraph);
      }
    }
  };

  const onOptimiseSessiondHandleChange = debounce(submitSessionDuration, 2000);

  async function changeDateForService(e) {
    // console.log("Change Data eeeee", e)
    await setCommonData({
      ...commonData,
      date_of_service: moment(e).format("MM/DD/Y"),
    });
    setTimeout(() => {
      $("#startProgressbutton").trigger("click");
    });
    if (e) {
      payloadData.date_of_service = moment(e).format("MM/DD/Y");
      const postdata = await postRequest(URL, payloadData, true);
      // console.log(postdata);
      if (postdata) {
        setStatement(postdata.paragraph);
        // setDefaultStatement(postdata.paragraph);
      }
    }
  }
  useEffect(() => {
    let mounted = true;

    const loadNoteData = async () => {
      setLoading(true);
      try {
        await getProgressNote();
        if (!mounted) {
          return;
        }
        if (editId > 0) {
          await setEditableCheckBox();
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadNoteData();

    return () => {
      mounted = false;
    };
  }, []);

  // React.useEffect(() => {
  //     const scrollDiv = document.getElementsByClassName('statementComponent__div')[0];
  //     scrollDiv.scrollTo(0, scrollDiv.offsetTop * 100)
  // }, [Statement])
  
  useEffect(() => {
    if (!viewEdit.confirmChange) {
      if ($(".scrollTODiv").length) {
        setTimeout(() => {
          $("#statementComponent__div_id_pn").animate({
            scrollTop:
              $("#statementComponent__div_id_pn").scrollTop() +
              ($(
                '#statementComponent__div_id_pn .scrollTODiv'
              ).offset()?.top -
                $("#statementComponent__div_id_pn").offset()?.top),
          });
        }, 20);
      }
    }
  },[Statement])

  const isPageLoading = loading || Boolean(commonData.isLoading);
  const isNoteStarted = viewEdit.client_document_id !== 0;
  const showDateEditButton = isNoteStarted || commonData.count === 1;
  const showTopRowExtraFields = !isPageLoading && isNoteStarted;
  const blockMainFormInteraction =
    isPageLoading ||
    (editId > 0 && !documentMetaLoaded) ||
    isViewOnlyDocument ||
    (isCustomPractice && !isNoteStarted);

  // console.log('progress note json', ProgressNoteJson);
  return (
    <React.Fragment>
      <div className="row g-6 g-xl-9 note-editor-layout">
        {isViewOnlyDocument ? (
          <div className="col-12">
            <div className="alert alert-info mb-0">
              This document has been signed and cannot be edited.
              {clinicianFinalSignOnly
                ? ' Review the note below and use Sign Doc to apply your signature.'
                : ' Use View to read the document.'}
            </div>
          </div>
        ) : null}
        {!viewEdit.confirmChange && !isViewOnlyDocument ? (
          <div className="col-lg-7 col-xxl-7 customUl">
            <div className="card h-100 note-form-card">
              <div className="card-body p-9">
                <div
                  className={`row g-3 g-lg-4 note-form-top-row progress-note-top-row${
                    isCustomPractice
                      ? ` custom-practice-top-row${
                          showTopRowExtraFields
                            ? ' progress-note-top-row--started'
                            : ' progress-note-top-row--before-start'
                        }`
                      : ''
                  }`}
                >
                  <div
                    className={`progress-note-top-date col-12 col-sm-12 ${
                      isCustomPractice
                        ? showTopRowExtraFields
                          ? 'col-12 col-lg-6 col-xl-4'
                          : 'col-md-8 col-lg-7 col-xl-6'
                        : showTopRowExtraFields
                          ? 'col-md-7 col-lg-6 col-xl-5'
                          : 'col-md-8 col-lg-7 col-xl-6'
                    }`}
                  >
                    <div className="note-form-field">
                      <label
                        className="form-label fw-bolder text-dark fs-6"
                        htmlFor="progress-note-date-of-service"
                      >
                        Date Of Service
                      </label>
                      <div className="note-form-field__control note-form-date-actions">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            inputFormat="MM/dd/yyyy"
                            value={moment.utc(moment(commonData.date_of_service)).format()}
                            onChange={changeDateForService}
                            disabled={loading}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                id="progress-note-date-of-service"
                                className="progress-note-date-picker-input"
                                fullWidth
                                hiddenLabel
                                placeholder="MM/DD/YYYY"
                                size="small"
                                disabled={loading}
                                inputProps={{
                                  ...params.inputProps,
                                  readOnly: loading,
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                        <div
                          className={`startEndDiv${
                            commonData.isLoading ? ' startEndDiv--loading' : ''
                          }`}
                        >
                        {isPageLoading ? (
                          <Loader
                            type="ThreeDots"
                            color="#017EAD"
                            height={32}
                            width={32}
                            timeout={300000}
                          />
                        ) : (
                          <button
                            className={`btn btn-primary allNotes__dateOfServices__btn${
                              showDateEditButton
                                ? ' allNotes__dateOfServices__btn--icon-only'
                                : ''
                            }`}
                            id="startProgressbutton"
                            onClick={submitDatefunction}
                            disabled={!commonData.date_of_service}
                            type="button"
                            aria-label={showDateEditButton ? "Edit date of service" : "Start progress note"}
                          >
                            {showDateEditButton ? (
                              <i className="fas fa-pencil-alt" />
                            ) : (
                              "Start Progress Note"
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  </div>

                  {showTopRowExtraFields ? (
                  <div
                    className={`progress-note-top-session col-12 col-sm-12 ${
                      isCustomPractice
                        ? 'col-12 col-lg-6 col-xl-4'
                        : 'col-md-5 col-lg-6 col-xl-3'
                    }`}
                  >
                    {isCustomPractice ? (
                      <CustomPracticeSessionDuration
                        minutesValue={resolveCustomPracticeDisplaySessionMinutes(
                          customPracticeMeta,
                          commonData.sessionDuration
                        )}
                        disabled={viewEdit.client_document_id === 0}
                        onDisabledClick={() =>
                          setCommonData((prev) => ({ ...prev, count: 2 }))
                        }
                      />
                    ) : (
                      <div className="note-form-field">
                        <label
                          className="form-label fw-bolder text-dark fs-6"
                          htmlFor="session_duration"
                        >
                          Session Duration
                        </label>
                        <div className="note-form-field__control">
                          <div className="input-group">
                            <input
                              className="form-control form-control-lg form-control-solid"
                              type="text"
                              disabled={viewEdit.client_document_id === 0}
                              defaultValue={commonData.sessionDuration}
                              onClick={() =>
                                viewEdit.client_document_id === 0
                                  ? setCommonData({ ...commonData, count: 2 })
                                  : null
                              }
                              onChange={onOptimiseSessiondHandleChange}
                              placeholder="15"
                              name="session_duration"
                              aria-describedby="session_duration_unit"
                              autoComplete="off"
                              id="session_duration"
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text form-control form-control-lg form-control-solid progress-note-session-unit"
                                id="session_duration_unit"
                              >
                                Min
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  ) : null}
                  {showTopRowExtraFields ? (
                  <div
                    className={`progress-note-top-replicate col-12 col-sm-12 ${
                      isCustomPractice
                        ? 'col-md-12 col-lg-12 col-xl-4'
                        : 'col-md-12 col-lg-12 col-xl-4'
                    }`}
                  >
                    <div className="note-form-field">
                      <div className="note-form-field__label-row">
                        <label
                          className="form-label fw-bolder text-dark fs-6 mb-0"
                          htmlFor="replicate-note-select"
                        >
                          Replicate note from:
                        </label>
                        {viewEdit.client_document_id !== 0 ? (
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0 note-form-field__refresh"
                            onClick={refreshReplicateList}
                            title="Refresh list"
                            aria-label="Refresh replicate note list"
                          >
                            <i className="fas fa-sync-alt" />
                          </button>
                        ) : (
                          <span className="note-form-field__label-spacer" aria-hidden="true" />
                        )}
                      </div>
                      <div className="note-form-field__control">
                        <select
                          id="replicate-note-select"
                          name="replicateNote"
                          className="form-select form-select-solid"
                          disabled={viewEdit.client_document_id === 0}
                          onClick={() =>
                            viewEdit.client_document_id === 0
                              ? setCommonData(prev => {
                                return { ...prev, count: 2 }
                              })
                              : null
                          }
                          onChange={getFields}
                          data-placeholder="ComboBox"
                        >
                          {commonData.replicateNoteData.length > 0 ? (
                            <>
                              <option value="0">Select Document</option>
                              {commonData.replicateNoteData.map((e, i) => (
                                <option key={i} value={e.id}>
                                  {e.date_of_service}
                                </option>
                              ))}
                            </>
                          ) : (
                            ""
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                  ) : null}
                  {(commonData.count == 11 ||
                    commonData.count == 22 ||
                    commonData.count > 1) && (
                    <div className="col-12">
                      <b className="text-danger d-block mt-1 mb-0">
                        {commonData.count == 11
                          ? "Please create a Treatment Plan to start Progress Note."
                          : "Please Start Progress Note"}
                      </b>
                    </div>
                  )}
                  {isCustomPractice && showTopRowExtraFields ? (
                    <CustomPracticeHeaderFields
                      meta={customPracticeMeta}
                      onFieldChange={onCustomPracticeFieldChange}
                      onFieldCommit={onCustomPracticeFieldCommit}
                      disabled={!contentEditable}
                    />
                  ) : null}
                </div>
                <div
                  className="note-form-main-section"
                  aria-busy={blockMainFormInteraction}
                >
                {blockMainFormInteraction ? (
                  <div
                    className="note-form-loading-overlay"
                    aria-hidden="true"
                  />
                ) : null}
                {(!isCustomPractice || showTopRowExtraFields) ? (
                <div
                  className="row fv-row mb-5"
                  style={{
                    position: "sticky",
                    top: "7%",
                    zIndex: 99,
                    background: "#fff",
                    padding: '10px 0px',
                  }}
                >

                  <div className="col-xs-12 col-md-12">
                    <div className="card-title">
                      <div className="d-flex align-items-center position-relative my-1">
                        <span className="svg-icon svg-icon-1 position-absolute ms-6">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              opacity="0.5"
                              x="17.0365"
                              y="15.1223"
                              width="8.15546"
                              height={2}
                              rx={1}
                              transform="rotate(45 17.0365 15.1223)"
                              fill="black"
                            />
                            <path
                              d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                        <input
                        ref={searchRef}
                          type="text"
                          id="searchContent"
                          className="form-control form-control-solid w-90% ps-15"
                          placeholder="Search Keyword..."
                          onChange={onOptimisedHandleChange}
                          disabled={!showTopRowExtraFields || commonData.count !== 1}
                        />
                        <button
                          style={{
                            backgroundColor: "#f5f8fa",
                            borderColor: "transparent",
                            borderRadius: 0,
                            padding: 10,
                          }}
                          onClick={clearSearch}
                          disabled={!showTopRowExtraFields || commonData.count !== 1}
                        >
                        x
                        </button>
                        <div
                          style={{
                            backgroundColor: "#f5f8fa",
                            borderColor: "#f5f8fa",
                            borderRadius: 0,
                            padding: 12,
                          }}
                        >
                          {totalSearch == 0 ? 0 : selectedSearchIndex + 1}/
                          {totalSearch}
                        </div>
                        <span
                        className="searchIndexUpDown"
                          style={{ padding: 10,}}
                          onClick={() => onSelectedSearchIndex("up")}
                        >
                          {/* <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M5.46967 14.5303C5.17678 14.2374 5.17678 13.7626 5.46967 13.4697L11.4697 7.46967C11.7626 7.17678 12.2374 7.17678 12.5303 7.46967L18.5303 13.4697C18.8232 13.7626 18.8232 14.2374 18.5303 14.5303C18.2374 14.8232 17.7626 14.8232 17.4697 14.5303L12 9.06066L6.53033 14.5303C6.23744 14.8232 5.76256 14.8232 5.46967 14.5303Z"
                              fill="#030D45"
                            />
                          </svg> */}
                          Prev
                        </span>
                        <span
                        className="searchIndexUpDown"
                          style={{ padding: 10 }}
                          onClick={() => onSelectedSearchIndex("down")}
                        >
                          {/* <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M18.5303 9.46967C18.8232 9.76256 18.8232 10.2374 18.5303 10.5303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17678 6.23744 9.17678 6.53033 9.46967L12 14.9393L17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967Z"
                              fill="#030D45"
                            />
                          </svg> */}
                          Next
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                ) : null}
                <div className="d-flex flex-column fv-row mb-7" style={{"position":"relative"}}>
                {searchLoader && <div style={{position:"absolute",height:"100%",width:"100%",display:"flex",justifyContent:"center",alignItems:"center",backdropFilter:"blur(2px)",zIndex:99999}}>
                         <Loader
                            type="ThreeDots"
                            color="#ffffff"
                            height={50}
                            width={50}
                            timeout={300000}
                          />
                </div>
              }
                  {/* {console.log(selectAllData)} */}

                  <Pare
                    selectAllData={selectAllData}
                    setStatement={(e) => {
                      setStatement(e)
                      // setDefaultStatement(e)
                    }}
                    setDurations={(z) => setDurations(z)}
                    setDateOfServices={(x) => setDateOfServices(x)}
                    setStatusCollapse={statusCollapse}
                    viewEdit={viewEdit}
                    setViewEdit={(e) =>
                      setViewEdit(prev => {
                        const session = getSession("userData") || {};
                        return {
                          ...prev,
                          client_document_id: e.client_document_id,
                          is_updated: e.is_updated,
                          created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
                        };
                      })
                    }
                    setAllData={setData}
                    data={ProgressNoteJson}
                    URL={URL}
                    editMode={viewEdit.editData}
                    notes_id={viewEdit.notes_id}
                    commonData={pareCommonData}
                    setpayloadsData={setPayloadData}
                    dataChildToParent={editDataofServies}
                    getDateOfService={getDateOfService}
                    // dateOFSERVICE ={setEditDate}
                    setSentenceLoader={setSentenceLoader}
                    setCheckboxLoader={setCheckboxLoader}
                    onFrontJsonPersisted={handleFrontJsonPersisted}
                    onFormSelectionChange={handleFormSelectionChange}
                    customPracticeMeta={
                      isCustomPractice ? customPracticeMeta : {}
                    }
                    customPracticeMetaRef={
                      isCustomPractice ? customPracticeMetaRef : null
                    }
                    accordionPreviewEpochRef={
                      isCustomPractice ? accordionPreviewEpochRef : null
                    }
                  />
                </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          className={`note-preview-column col-lg-${
            !viewEdit.confirmChange ? 5 : 12
          } col-xxl-${!viewEdit.confirmChange ? 5 : 12}`}
        >
          <div className="card note-preview-card">
            <div className="card-body p-9 note-preview-card-body">
            { sentenceLoader && <div style={{
                                        position:'absolute',
                                        top:0,
                                        left:0,
                                        height:"100%",
                                        width:"100%",
                                        backdropFilter: "blur(1.5px)",
                                        zIndex: 99999,
                                        pointerEvents: 'none',
                                    }}>
                                      <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%", width:"100%",}}>
                                        <Loader
                                          type="ThreeDots"
                                          color="#017EAD"
                                          height={50}
                                          width={50}
                                          timeout={300000} />
                                      </div>
                                </div>
              }
              {viewEdit.confirmChange &&
              <div className="d-flex gap-2 justify-content-end align-items-center">
                <h3 className="m-0 text-primary-emphasis">Change language: </h3>
                <button className="btn btn-primary" style={{padding: "5px 10px 5px 15px"}} onClick={() => {
                  // console.log()
                  setStatement(defaultStatement)
                  setViewEdit(prev => {
                    return {
                      ...prev,
                      wordsReplaced:false,
                    }
                  })
                  }}>
                  Default
                </button>
                {/* <button class="btn btn-primary" style={{padding: "5px 10px 5px 15px"}} onClick={() => {
                  const newSentence = keepSentenceBetweenSpecificWords(sentence, "MSE", "Goal 1:")
                  console.log("sentence",Statement)
                  console.log("newSentence",newSentence)
                }}>
                  Option NA
                </button> */}
                <button className="btn btn-primary" style={{padding: "5px 10px 5px 15px"}} onClick={() => replaceWords(defaultStatement,replaceWords1)}>
                  Option 1
                </button>
                <button className="btn btn-primary" style={{padding: "5px 10px 5px 15px"}} onClick={() => replaceWords(defaultStatement,replaceWords2)}>
                  Option 2
                </button>
              </div>
              }
              <div className="">
                {viewEdit.confirmChange ? (
                  viewEdit.diagnosis ? (
                    <div>
                      <h2>Diagnosis</h2>
                      {viewEdit.diagnosis.map((e) => {
                        return e.diagnosis !== null ? (
                          <div className="d-inline-block bg-grey rounded selected_diagnosis m-2">
                            <div className="d-flex selected_diagnosis__div">
                              <p>{e.diagnosis.name} </p>
                            </div>
                          </div>
                        ) : (
                          ""
                        );
                      })}
                      <hr />
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
              <div className="note-preview-header cust__diagnosis_addNew_spaceBet">
                <label className="form-label text-dark fs-6 mb-0">
                  <span className="fw-bolder">{userInfo.full_name}</span>
                  {Statement || viewEdit.client_document_id > 0 ? (
                    <>
                      <br />
                      <span>
                        <span className="fw-bolder">DOB:</span>{" "}
                        {moment(userInfo.dob).format("MM/DD/Y")}
                      </span>
                    </>
                  ) : null}
                </label>
                <label className="form-label text-dark fs-6 mb-0 note-preview-header__meta">
                  <span className="fw-bolder">Progress Note</span>
                  <br />
                  {Statement || viewEdit.client_document_id > 0 ? (
                    <div>
                      {DateOfServices || commonData.date_of_service ? (
                        <label>
                          <span className="fw-bolder">Date Of Service: </span>{" "}
                          {moment(
                            DateOfServices
                              ? DateOfServices
                              : commonData.date_of_service
                          ).format("MM/DD/Y")}
                        </label>
                      ) : null}
                    </div>
                  ) : null}
                </label>
              </div>
              <div
                className={`d-flex flex-column statementComponent__div fv-row mb-7${
                  viewEdit.confirmChange
                    ? " statementComponent__div--editor"
                    : " scroll_statement_div"
                }`}
                id="statementComponent__div_id_pn"
                style={
                  viewEdit.confirmChange
                    ? { scrollPaddingTop: "50px" }
                    : { maxHeight: "500px", scrollPaddingTop: "50px" }
                }
              >
                {viewEdit.confirmChange ? (
                  <CKEditor
                    editor={ClassicEditor}
                    name="test"
                    config={{
                      toolbar: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "link",
                        "bulletedList",
                        "numberedList",
                        "blockQuote",
                      ],
                    }}
                    data={Statement}
                    onChange={(event, editor) => {
                      setStatement(editor.getData())
                    //   if(!viewEdit.wordsReplaced){
                    //   setDefaultStatement(editor.getData())
                    // }
                    }}
                  >
                    {" "}
                  </CKEditor>
                ) : (
                  <div
                    className="fs-6 text-dark form-label mb-0"
                    id="progressNote"
                    // ref={containerRef}
                  >
                    <div
                      style={{ fontSize: "16px" }}
                      dangerouslySetInnerHTML={{ __html: Statement }}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-wrap fv-row mb-7">
                {Statement !== "" ? (
                  <button
                    className="btn btn-primary btn-sm me-3 mb-3"
                    onClick={() => {
                      setViewEdit(prev => {
                        return { ...prev, viewStatement: true }
                      });
                    }}
                  >
                    View
                  </button>
                ) : (
                  ""
                )}
                {showDocumentEditActions ? (
                  viewEdit.confirmChange ? (
                    <button
                      className="btn btn-info btn-sm me-3 mb-3"
                      onClick={() => saveStatement()}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn btn-info btn-sm me-3 mb-3"
                      disabled={Statement == "" ? true : false}
                      onClick={() => saveStatement()}
                    >
                      Save
                    </button>
                  )
                ) : null}
                {showDocumentEditActions && !viewEdit.confirmChange ? (
                  <button
                    className="btn btn-danger btn-sm me-3 mb-3"
                    disabled={Statement == "" ? true : false}
                    onClick={() =>
                      setViewEdit(prev => {
                        return { ...prev, showModal: true }
                      })
                    }
                  >
                    Manually edit
                  </button>
                ) : null}
                {(Statement !== "" || (showSigned == 0 || viewEdit.is_updated !== 0)) ? (
                  // Clinician final sign or sign request — content edits disabled when locked
                  <button
                    className="btn btn-success btn-sm me-3 mb-3"
                    onClick={() =>
                      setSignOff({
                        ...SignOff,
                        signOff: true,
                        supervisor_signed: supervisorSigned,
                        signed: checkSigned,
                      })
                    }
                  >
                    {/* {checkSigned === 3 ? "Sign Request" : (supervisorSigned == 2 && checkSigned == 2) ? "Sign Request" :"Sign Doc"} */}
                                            {getSignOffButtonLabel(checkSigned)}
                  </button>
                ) : (
                  ""
                )}
                {
                  <button
                    className="btn btn-warning btn-sm me-3 mb-3"
                    onClick={downloadDocument}
                    disabled={Statement === ""}
                  >
                    <i
                      className="fa fa-file-download"
                      style={{ width: "10px" }}
                    ></i>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
        <CustModal
          show={viewEdit.showModal}
          close={() => setViewEdit(prev => {
            return { ...prev, showModal: false }
          })}
          header="Are you sure you would like to manually edit your text now?"
        >
          <div className="row">
            <div className="col-xs-12">
              <div className="h5">
                Are you sure you want to manually edit your document? Once you
                do, you will no longer have access to the keywords.
              </div>
            </div>
            <div className="col-xs-12 mt-4">
              <div className="">
                <button
                  className="btn btn-primary mx-2"
                  onClick={() =>{
                    setDefaultStatement(Statement)
                      setViewEdit(prev => {
                      return {
                      ...prev,
                      showModal: false,
                      confirmChange: true,
                    }
                    })
                  }
                  }
                >
                  Yes, manually edit
                </button>
                <button
                  className="btn btn-danger mx-2"
                  onClick={() => setViewEdit(prev => {
                    return { ...prev, showModal: false }
                  })}
                >
                  No, return to keyword selections
                </button>
              </div>
            </div>
          </div>
        </CustModal>
        <CustModal
          show={SignOff.signOff}
          close={() => setSignOff({ ...SignOff, signOff: false })}
          header="Alert!"
          size="sm"
        >
          <div className="row">
            <div className="col-xs-12">
              <h4>
                Are you sure you would like to {getSignOffConfirmPrompt(checkSigned)} ?
              </h4>
            </div>
            <div className="col-xs-12 mt-4">
              <div className="">
                <button
                  className="btn btn-primary mx-2"
                  onClick={() => signOffFun()}
                >
                 Confirm
                </button>
                <button
                  className="btn btn-danger mx-2"
                  onClick={() => setSignOff({ ...SignOff, signOff: false })}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </CustModal>

        <CustModal
          show={viewEdit.viewStatement}
          close={() => setViewEdit(prev => {
            return { ...prev, viewStatement: false }
          })}
          header={userInfo.full_name}
          size="lg"
          centerHeader="Progress Note"
        >
          <div className="row">
            {/* <div className="col-xs-12">                            
                            {
                                viewEdit.diagnosis
                                ? <div>
                                    <h4>Diagnosis</h4>
                                    {
                                        viewEdit.diagnosis.map((e) => {
                                            return e.diagnosis !== null
                                                ? <div className='d-inline-block bg-grey rounded selected_diagnosis m-2'>
                                                    <div className='d-flex selected_diagnosis__div'>
                                                        <p>{e.diagnosis.name}  </p>
                                                    </div>
                                                </div>
                                                : ""
                                        }
                                        )
                                    }
                                    <hr />
                                </div>
                                : ""
                            }
                        </div> */}
            <div className="col-xs-12">
              <div dangerouslySetInnerHTML={{ __html: stripEmbeddedSignaturesFromHtml(Statement) }} />
            </div>
            {viewEdit.signed == 2 || viewEdit.supervisorSigned == 2 ? (
              <div className="col-xs-12 mt-4">
                <hr />
                {(() => {
                  const signatures = resolveDocumentSignatures({
                    signed: viewEdit.signed,
                    supervisor_signed: viewEdit.supervisorSigned,
                    signature: viewEdit.signature,
                    supervisor_signature: viewEdit.supervisor_signature,
                    signed_at: viewEdit.editTime,
                    supervisor_signed_at: viewEdit.supervisor_signed_at,
                    status_updated_by_role: viewEdit.status_updated_by_role,
                    created_by: viewEdit.created_by,
                    supervisor_signed_by: viewEdit.supervisor_signed_by,
                  });
                  return (
                    <>
                      {signatures.clinician.show ? (
                        <p>{formatSignatureLine(signatures.clinician.text, signatures.clinician.at)}</p>
                      ) : null}
                      {signatures.supervisor.show ? (
                        <p>{formatSignatureLine(signatures.supervisor.text, signatures.supervisor.at)}</p>
                      ) : null}
                    </>
                  );
                })()}
              </div>
            ) : (
              ""
            )}
            <div className="col-xs-12 mt-4">
              <hr />
              <div className="">
                <button
                  className="btn btn-primary rounded-sm mx-2"
                  onClick={() =>
                    setViewEdit(prev => {
                      return { ...prev, viewStatement: false }
                    })
                  }
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </CustModal>

        <CustModal
          show={viewEdit.confirmSave}
          close={() => setViewEdit(prev => {
            return { ...prev, confirmSave: false }
          })}
          header="Success"
          size="sm"
        >
          <div className="row">
            <div className="col-xs-12">
              <h4>Document is saved</h4>
            </div>
            <div className="col-xs-12 mt-4">
              <div className="">
                <button
                  className="btn btn-primary mx-2"
                  onClick={() => changePage({ id: 6 })}
                >
                  Go to Profile
                </button>
                <button
                  className="btn btn-danger mx-2"
                  onClick={() =>
                    setViewEdit(prev => {
                      return { ...prev, confirmSave: false }
                    })
                  }
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </CustModal>
      </div>
    </React.Fragment>
  );
}
